import { createFileRoute } from '@tanstack/react-router';
import { Suspense } from 'react';

import { HStack, VStack } from '@/components/Layout';
import { Skeleton } from '@/components/ui/skeleton';

import { TestSetDetailHeader } from './-components/TestSetDetailHeader';
import { TestSetDetailOutletWithForm } from './_layout/-context/test-set-tab-form-context';
import { TestSetFormStore } from './_layout/-store/store';

export const Route = createFileRoute('/_stacktrace/test-sets/$id/_layout')({
  component: Layout,
});

function TestSetDetailHeaderSkeleton() {
  return (
    <VStack className="gap-4 bg-neutral-fill px-12 pt-4 shadow-xs">
      <Skeleton className="h-5 w-64" />
      <HStack className="items-start justify-between gap-6">
        <HStack className="items-start gap-4 grow">
          <Skeleton className="size-12 shrink-0" />
          <VStack className="grow gap-2">
            <Skeleton className="h-6 w-24 rounded-full" />
            <Skeleton className="h-8 w-72" />
            <Skeleton className="h-5 w-48" />
          </VStack>
        </HStack>
        <VStack className="shrink-0 items-end gap-2">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-4 w-24" />
        </VStack>
      </HStack>
      <Skeleton className="h-10 w-full" />
    </VStack>
  );
}

function Layout() {
  // 概要タブの全セクションで同一フォームストアを共有するため、ここで Provider を張る。
  // useTestSetTabForm は useGetTestSet(Suspense)を使うので Suspense 境界の内側で実行する。
  const store = TestSetFormStore.createStore();
  return (
    <VStack>
      <Suspense fallback={<TestSetDetailHeaderSkeleton />}>
        <TestSetDetailHeader />
      </Suspense>
      <Suspense fallback={<div className="flex-1 px-12 py-5" />}>
        <TestSetFormStore.Provider value={store}>
          <TestSetDetailOutletWithForm />
        </TestSetFormStore.Provider>
      </Suspense>
    </VStack>
  );
}
